export const REQUIRED_ERROR = 'Поле не может быть пустым';
export const REQUIRED_ERROR_FOR_CARRY_OUT = 'Необходимо заполнить обязательные для проведения КНМ поля';
export const MAX_CHARACTERS_ERROR = 'Превышена допустимая длина строки';
export const MIN_CHARACTERS_ERROR = (count: number) => `Минимальная допустимая длина: ${count}`;
export const UNALLOWED_CHARACTERS_ERROR = 'Введены недопустимые символы';
export const START_DATE_NO_LATER_STOP_DATE_ERROR = 'Дата начала должна быть меньше или равна дате окончания';
export const STOP_DATE_NO_SOONER_START_DATE_ERROR = 'Дата окончания должна быть больше или равна дате начала';
export const INN_ERROR = (isIp?: boolean) =>
  `Некорректный ИНН, ИНН может состоять только из 10 символов для ЮЛ, 12 символов для ${isIp ? 'ИП' : 'ФЛ'}`;
export const OGRN_LENGTH_ERROR =
  'Некорректный ОГРН, ОГРН может состоять только из 13 символов для ЮЛ, 15 символов для ИП';
export const OGRN_ERROR = 'Некорректный ОГРН';
export const OGRN_ZERO_ERROR = 'Некорректный ОГРН, ОГРН не может начинаться с 0';
export const RAFP_NZA_ERROR =
  'Некорректный Номер записи об аккредитации в РАФП, номер может состоять только из 11 символов';
export const KPP_ERROR = 'Некорректный код причины постановки на учет, КПП может состоять только из 9 символов';
export const KNM_SUBJECT_IS_EXIST_ERROR = 'Контролируемое лицо уже присутствует в паспорте КНМ';
export const KNM_SUBJECT_IS_EXIST_AT_ACT_ERROR =
  'Контролируемое лицо уже присутствует в паспорте КНМ, выберите его из списка существующих либо укажите другое контролируемое лицо';
export const FIELD_INCORRECTLY = 'Поле заполнено некорректно';
export const APPLICATION_CONDITION_SUBJECT_REQUIRED =
  'Контролируемые лица должны соответствовать перечню КЛ, доступных для проведения для выбранного основания или поручения.';
